import type { InstallmentStatus, SequenceStatus } from '@beta-assur/shared';
import { useT } from '../lib/i18n';
import { Badge, type Tone } from './ui/badge';

const INSTALLMENT_TONES: Record<InstallmentStatus, Tone> = {
  upcoming: 'neutral',
  due: 'info',
  overdue: 'danger',
  partial: 'warning',
  paid: 'success',
  waived: 'neutral',
  cancelled: 'neutral',
};

const SEQUENCE_TONES: Record<SequenceStatus, Tone> = {
  scheduled: 'info',
  running: 'info',
  paused: 'warning',
  stopped_paid: 'success',
  stopped_optout: 'neutral',
  stopped_manual: 'neutral',
  escalated: 'danger',
  completed: 'neutral',
};

export function InstallmentStatusBadge({ status }: { status: InstallmentStatus }) {
  const t = useT();
  return <Badge tone={INSTALLMENT_TONES[status]}>{t.status[status]}</Badge>;
}

export function SequenceStatusBadge({ status }: { status: SequenceStatus }) {
  const t = useT();
  return <Badge tone={SEQUENCE_TONES[status]}>{t.sequenceStatus[status]}</Badge>;
}

export function ContractStatusBadge({
  status,
}: {
  status: keyof ReturnType<typeof useT>['contractStatus'];
}) {
  const t = useT();
  const tone: Tone =
    status === 'active' ? 'success' : status === 'suspended' ? 'warning' : 'neutral';
  return <Badge tone={tone}>{t.contractStatus[status]}</Badge>;
}
